import { render } from "./ExportDomesticiAziendeRappresentanti.vue?vue&type=template&id=67ce6aea&scoped=true"
import script from "./ExportDomesticiAziendeRappresentanti.vue?vue&type=script&lang=js"
export * from "./ExportDomesticiAziendeRappresentanti.vue?vue&type=script&lang=js"

import "./ExportDomesticiAziendeRappresentanti.vue?vue&type=style&index=0&id=67ce6aea&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ce6aea"]])

export default __exports__